import { Injectable } from '@angular/core';

/**
 * Reads `BuildConfig.VERSION_NAME` from the way-saas-android WebView bridge
 * (`TapToPayWebJavascriptBridge` → `window.TapToPayAndroid.getAppVersion()`).
 */
@Injectable({ providedIn: 'root' })
export class AndroidAppNativeService {
  private cachedVersion: string | null | undefined;

  /** True when Angular runs inside the way-saas-android WebView shell. */
  get isAndroidShell(): boolean {
    return typeof window !== 'undefined' && typeof window.TapToPayAndroid?.getAppVersion === 'function';
  }

  /** Native app version (e.g. `1.0.2`). Null in desktop/mobile browser. */
  getAppVersion(): string | null {
    if (this.cachedVersion !== undefined) {
      return this.cachedVersion;
    }

    if (typeof window === 'undefined') {
      this.cachedVersion = null;
      return null;
    }

    try {
      const bridge = window.TapToPayAndroid;
      if (typeof bridge?.getAppVersion === 'function') {
        const version = String(bridge.getAppVersion() ?? '').trim();
        this.cachedVersion = version || null;
        return this.cachedVersion;
      }
    } catch {
      /* bridge not ready */
    }

    this.cachedVersion = null;
    return null;
  }
}
